export default "__VITE_ASSET__CJtsDtkq__"